import nftMarketplaceAbi from '../../../abis/NFTMarketPlace.json';
import { useAsyncFn } from 'react-use';
import { useConfig } from '@app/config';
import { useContract } from '@thirdweb-dev/react-core';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { useNftMarketplaceFiltersState } from '@app/state/nftMarketplaceFiltersStore';

type QueryParams = {
  listings: NFTMarketplaceListing[];
};

export function useBulkBuyNow() {
  const config = useConfig();
  const { contract: nftMarketplaceContract } = useContract(
    config?.CONTRACTS.NFT_MARKETPLACE,
    nftMarketplaceAbi
  );
  const { ownedPremiumNFTTokenId } = useNftMarketplaceFiltersState();

  const [{ value, loading, error }, bulkBuyNow] = useAsyncFn(
    async (params: QueryParams) => {
      const { listings } = params;
      const listingIds = listings.map(listing => {
        return listing.id;
      });
      const optionalPremiumTokenIds = listings.map(listing => {
        if (listing.nftMetadata.isPremium) {
          return ownedPremiumNFTTokenId;
        } else {
          return 0;
        }
      });

      // @ts-ignore
      return await nftMarketplaceContract.call('bulkBuyItNow', [
        listingIds,
        optionalPremiumTokenIds
      ]);
    },
    [nftMarketplaceContract, ownedPremiumNFTTokenId]
  );

  return {
    transactionHash: value,
    loading,
    error,
    bulkBuyNow
  };
}
